import ApplicationSerializer from './application';

export default class BacklinkViewSerializer extends ApplicationSerializer {
  serializeIntoHash(data, _type, record) {
    super.serializeIntoHash(...arguments);
    data.url_id = record.belongsTo('url').id;
    data.backlink_view.search_keyword_url_id = data.url_id;
  }
}
